// extracted by mini-css-extract-plugin
export default {"container":"B32SfzQWNSrz3u0dwqht","row":"Xt3XaP0ZkYTbt6tZqZMy"};